import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { defaultWebsiteSections, normalizeWebsiteSections } from '../config/websiteSections';
import { publicApi } from '../services/publicApi';

const WebsiteSectionsContext = createContext(defaultWebsiteSections);

export function WebsiteSectionsProvider({ children }) {
  const [sections, setSections] = useState(defaultWebsiteSections);

  useEffect(() => {
    let isMounted = true;

    const loadSections = async () => {
      try {
        const data = await publicApi.getWebsiteSections();
        if (isMounted) {
          setSections(normalizeWebsiteSections(data));
        }
      } catch {
        if (isMounted) {
          setSections(defaultWebsiteSections);
        }
      }
    };

    loadSections();
    return () => {
      isMounted = false;
    };
  }, []);

  const value = useMemo(() => sections, [sections]);

  return <WebsiteSectionsContext.Provider value={value}>{children}</WebsiteSectionsContext.Provider>;
}

export function useWebsiteSections() {
  return useContext(WebsiteSectionsContext);
}
